import * as Immutable from "immutable";
import URI from "urijs";
import Routes from "routing/Routes";
import { timeRangeToQueryParameter } from "views/logic/TimeRange";
import { addToQuery, escape } from "views/logic/queries/QueryHelper";
const _mergeFilterFieldsToQuery = (query, filterFields = {}) => Object.keys(filterFields).filter((key) => filterFields[key] !== null && filterFields[key] !== void 0).map((key) => `${key}:"${escape(String(filterFields[key]))}"`).reduce((prev, cur) => addToQuery(prev, cur), query ? query.query_string : "");
export default class SearchLink {
  constructor(id, timerange, query, streams, streamCategories, highlightedMessage, filterFields) {
    this._value = {
      id,
      timerange,
      query,
      streams,
      streamCategories,
      highlightedMessage,
      filterFields
    };
  }
  get id() {
    return this._value.id;
  }
  get timerange() {
    return this._value.timerange;
  }
  get query() {
    return this._value.query;
  }
  get streams() {
    return this._value.streams;
  }
  get streamCategories() {
    return this._value.streamCategories;
  }
  get highlightedMessage() {
    return this._value.highlightedMessage;
  }
  get filterFields() {
    return this._value.filterFields;
  }
  static builder() {
    return new Builder();
  }
  toURL() {
    const { id, query, highlightedMessage, streams, streamCategories, filterFields, timerange } = this._value;
    const queryWithFilterFields = _mergeFilterFieldsToQuery(query, filterFields);
    const searchTimerange = timerange ? timeRangeToQueryParameter(timerange) : {};
    const params = {
      ...searchTimerange,
      q: queryWithFilterFields === "" ? void 0 : queryWithFilterFields,
      highlightMessage: highlightedMessage
    };
    const paramsWithStreams = streams && streams.length > 0 ? { ...params, streams: streams.join(",") } : params;
    const paramsWithStreamsAndCategories = streamCategories && streamCategories.length > 0 ? { ...params, stream_categories: streamCategories.join(",") } : paramsWithStreams;
    const urlPrefix = id ? `${Routes.SEARCH}/${id}` : Routes.SEARCH;
    const uri = new URI(urlPrefix).setSearch(paramsWithStreamsAndCategories);
    return uri.toString();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  id(value) {
    return new Builder(this.value.set("id", value));
  }
  timerange(value) {
    return new Builder(this.value.set("timerange", value));
  }
  query(value) {
    return new Builder(this.value.set("query", value));
  }
  streams(value) {
    return new Builder(this.value.set("streams", value));
  }
  streamCategories(value) {
    return new Builder(this.value.set("streamCategories", value));
  }
  highlightedMessage(value) {
    return new Builder(this.value.set("highlightedMessage", value));
  }
  filterFields(value) {
    return new Builder(this.value.set("filterFields", value));
  }
  build() {
    const { id, timerange, query, streams, streamCategories, highlightedMessage, filterFields } = this.value.toObject();
    return new SearchLink(id, timerange, query, streams, streamCategories, highlightedMessage, filterFields);
  }
}
